import React, { Component } from 'react';
import { bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import {Form} from 'semantic-ui-react';
import PropTypes from 'prop-types';

class ShipStationWarehouseSelector extends Component {
    rtnObjectSelectedValue = (value) => {
        const {couriers, onSelectChange} = this.props;
        const record = couriers.filter(i => {
            return _.toString(i.id) === value;
        });

        if (record.length > 0) {
            return onSelectChange(record[0]);
        } else {
            return {
                id: "0",
                name: "NA",
                client_id: null
            }
        }
    }
    
    render() {
        const {warehouses, appendNonOption, returnObject, label, selected, onSelectChange} = this.props;
        const options = [];
        _.each(warehouses, c => {
            options.push({
                value: _.toString(c.warehouseId),
                text: c.warehouseName,
                key: c.id
            });
        });
        if (appendNonOption) {
            options.unshift({
                value: "0",
                text: "NA",
                key: 0
            });
        }
        return (
            <Form.Select fluid search selection 
                label={label}
                options={options}
                name="ss_warehouse_id" value={selected ? _.toString(selected) : "0"} 
                onChange={(e, {value}) => {
                    returnObject ? this.rtnObjectSelectedValue(value) : onSelectChange(value)
                }}
            />
        )
    }
}

ShipStationWarehouseSelector.propTypes = {
    onSelectChange: PropTypes.func.isRequired,
    warehouses: PropTypes.array.isRequired,
    label: PropTypes.string,
    selected: PropTypes.any
    //history: PropTypes.shape({
    //    push: PropTypes.func.isRequired
    //}).isRequired,
};

function mapStateToProps(state) {
    return {
        warehouses: state.system.ship_station.warehouses
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ShipStationWarehouseSelector)